import React from 'react'
import { connect } from 'react-redux'

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import { Radio, Input, Row, Col } from 'antd';
import { Checkbox, Slider, Select, Switch, Button, Form, message } from 'antd';
import Card, { TitleCard } from '../../core/Card'
import { FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../../core/icons'
import {Field, reduxForm, submit} from 'redux-form'
import { save, toggleDay } from './actions'
import { toSlider, toAMPM, sliderToTime, formatHourRange } from './reducer'
import makeField from '../makeField'
import './WorkHours.css'

const Option = Select.Option;

const DayRange = ({ toggleDay, input, meta, children, hasFeedback, label, ...rest }) =>
  <Row className="DayRange" type="flex" justify="start" align="top">
    <Col span={2}>
      <Checkbox className="checkbox-large" checked={input.value} onChange={()=>toggleDay(label)}/>
    </Col>
    <Col span={22}>
      <Row type="flex" justify="space-between" align="top">
        <Col span={12}>
          <label>{label}</label>
        </Col>
        <Col span={12}>
          {input.value
            ? <label style={{float: 'right'}}>{toAMPM(input.value[0])} - {toAMPM(input.value[1])}</label>
            : <label style={{width: '150px'}}></label>
          }
        </Col>
      </Row>
      <Row type="flex" justify="start" align="top">
        {
          input.value &&
          <div className="Slider">
              <Slider
                tipFormatter={toAMPM}
                step={0.5}
                min={0} max={24}
                range
                {...input}
                {...rest}
              />
          </div>
        }
      </Row>
    </Col>
  </Row>

const ASlider = makeField(Slider)
const ASwitch = makeField(Switch)
const ASelect = makeField(Select)

const WorkHours = ({onAfterChange, toggleDay, incomeSources, pristine, disabled, submitting, onRemoteSubmit, ...props}) =>
  <div className="WorkHours">

    <TitleCard sticky>
      <h1>Work Hours</h1>
      <Button loading={submitting} onClick={onRemoteSubmit} type="primary">Save</Button>

    </TitleCard>

    <Card>

      <div className="Options">
        <Field label="Enable Work Hours"
          name="enabled"
          component={ASwitch}
          premiumOnly
          type="checkbox"
        />

        <Field label="Within these hours:"
          name="inside"
          component={ASelect}
          type="select"
          style={{ width: 120 }}
          >
            {incomeSources.map(source => <option value={source}>{source}</option>)}
          </Field>

          <Field label="Outside these hours:"
            name="outside"
            component={ASelect}
            type="select"
            style={{ width: 120 }}
            >
              {incomeSources.map(source => <option value={source}>{source}</option>)}
            </Field>

           <hr/>
      </div>

      {
        ['Monday','Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        .map((day, i)=>
          <Field label={`${day}`}
            component={DayRange}
            name={`${day}`}
            toggleDay={toggleDay}
            onAfterChange={(e)=>onAfterChange(e, day)}
          />
        )
      }
    </Card>
  </div>


const mapStateToProps = (state) => {
  return {
    ...state.account.workHours,
    initialValues: state.account.workHours,
    enableReinitialize: true,
    incomeSources: [
      ...state.account.businessLines.active,
      'Work',
      'Unclassified',
      'Personal',
      'Medical',
      'Charity',
      'Moving',
      'Commute'
    ],

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onRemoteSubmit: () => dispatch(submit('workHoursForm')),
    toggleDay: (day) => dispatch(toggleDay(day)),
    onAfterChange: (range,day)=> dispatch({type: 'UPDATE_WORK_HOURS_RANGE', payload: {day, range}})
  }
}
const WorkHoursForm = reduxForm({
  form: 'workHoursForm',  // a unique identifier for this form
  onSubmit: (values, dispatch, ownProps)=> dispatch(save(values))
    .then(()=>message.success('Work hours successfully updated.', 10))
    .catch((error)=>{
      console.log({error})
      // message.warn('Unlock premium to be able to save your work hours.', 10)
    })
})(WorkHours)

export default connect(mapStateToProps, mapDispatchToProps )(WorkHoursForm)



// WEBPACK FOOTER //
// ./src/account/work-hours/WorkHours.js